import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUp, Users, Target } from 'lucide-react';

const stats = [
  {
    icon: TrendingUp,
    value: '35%',
    label: 'Average Revenue Growth',
    description: 'Our clients see significant revenue increases within the first year'
  },
  {
    icon: Users,
    value: '500+',
    label: 'Businesses Transformed',
    description: 'Helping companies across industries achieve their goals'
  },
  {
    icon: Target,
    value: '98%',
    label: 'Client Success Rate',
    description: 'Our clients consistently meet or exceed their business objectives'
  }
];

const springConfig = {
  type: "spring",
  stiffness: 50,
  damping: 20,
  mass: 1
};

export const Impact = () => {
  return (
    <section className="relative py-20 px-4">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1, ...springConfig }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            <span className="bg-gradient-to-r from-amber-200 to-amber-400 text-transparent bg-clip-text">
              Our Impact
            </span>
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            We empower business owners with daily insights, strategic guidance, and accountability-driven execution support.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {stats.map((stat, index) => (
            <motion.div
              key={stat.label}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.2, duration: 1, ...springConfig }}
              className="relative p-6 bg-gradient-to-b from-amber-400/5 to-transparent rounded-xl border border-amber-400/10 backdrop-blur-sm group"
            >
              <motion.div
                whileHover={{ scale: 1.1 }}
                transition={springConfig}
                className="w-12 h-12 mb-4 bg-amber-400/10 rounded-lg flex items-center justify-center group-hover:bg-amber-400/20 transition-colors duration-700"
              >
                <stat.icon className="w-6 h-6 text-amber-400" />
              </motion.div>
              <h3 className="text-4xl font-bold text-white mb-2">{stat.value}</h3>
              <h4 className="text-xl font-semibold text-amber-400 mb-2">{stat.label}</h4>
              <p className="text-gray-400">{stat.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};